module.exports = __webpack_public_path__ + "static/media/volver.227f22fd.svg";